import React from 'react';
import { motion } from 'framer-motion';
import { useSwitchChain, useChainId } from 'wagmi';
import { CHAIN_IMAGES } from '../config/chainImages';
import './SwapNetworkSelector.css';

const networks = [
  { id: 1, name: 'Ethereum', icon: CHAIN_IMAGES[1], chainId: 1 },
  { id: 8453, name: 'Base', icon: CHAIN_IMAGES[8453], chainId: 8453 },
  { id: 10, name: 'Optimism', icon: CHAIN_IMAGES[10], chainId: 10 },
  { id: 42161, name: 'Arbitrum', icon: CHAIN_IMAGES[42161], chainId: 42161 },
  { id: 146, name: 'Sonic', icon: CHAIN_IMAGES[146], chainId: 146 },
  { id: 43114, name: 'Avalanche', icon: CHAIN_IMAGES[43114], chainId: 43114 },
  { id: 59144, name: 'Linea', icon: CHAIN_IMAGES[59144], chainId: 59144 },
  { id: 130, name: 'Unichain', icon: CHAIN_IMAGES[130], chainId: 130 },
  { id: 137, name: 'Polygon', icon: CHAIN_IMAGES[137], chainId: 137 },
];

const SwapNetworkSelector = ({ onNetworkChange }) => {
  const currentChainId = useChainId();
  const { switchChain } = useSwitchChain();

  const handleNetworkClick = async (network) => {
    try {
      await switchChain({ chainId: network.chainId });
      if (onNetworkChange) {
        onNetworkChange(network.chainId);
      }
    } catch (error) {
      console.error('Failed to switch network:', error);
    }
  };

  return (
    <div className='swap-network-selector'>
      <div className='network-icons-container'>
        {networks.map((network) => (
          <div key={network.id} className={`network-icon-wrapper ${currentChainId === network.chainId ? 'active' : ''}`} onClick={() => handleNetworkClick(network)} title={network.name}>
            <img src={network.icon} alt={network.name} className='network-icon' />
            {currentChainId === network.chainId && <div className='active-indicator'></div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SwapNetworkSelector;
